import React from "react";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";

import UserReport from "./users/UserReport";
import OrganizationReport from "./organization/OrganizationReport";

function ReportsSection() {
  const { t } = useTranslation();
  return (
    <Container fluid>
      <Breadcrumbs mainTitle={t("Reports")} parent={t("Reports")} />
      <Row>
        <UserReport />
        <OrganizationReport />
      </Row>
    </Container>
  );
}

export default ReportsSection;
